<template>
  <div>
    <section>
      <div 
        class="title font-weight-bold black--text"
        style="opacity: 70%;">
        #Kesehatan Sentana
      </div>
          
      <div>
        <tables :config="config()" />
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    watch: {
      
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      }
    },
    mounted () {

    },
    methods: {
      config () {
        return {
          // CONFIG PARSING API
          api: `admin/user_medical?user_id=${this.$route.params.id}`,

          // SINGLE
          single: true,

          // CHECKBOX
          checkbox: false,

          // PADDING
          padding: 'pa-0',

          // HEIGHT
          height: true,

          // SHADOW
          shadow: false,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'Catatan',
              width: '400px',
              value: 'note',
              freeze: false,
              hide: false
            },
            {
              text: 'Tanggal',
              width: '200px',
              value: 'date',
              freeze: false,
              hide: false,
              format: 'date'
            }
          ],

          // CONFIG PARSING FILTER
          filter: [],

          // PREFIX KEY
          prefix: '',

          // CONFIG PARSING FORM
          form: [
            {
              field: 'id',
              label: 'ID',
              type: 'id',
              placeholder: 'Contoh. 1',
              value: '',
              width: '20%',
              required: false,
              hide: true
            },
            {
              field: 'user_id',
              label: 'USER ID',
              type: 'id',
              placeholder: 'Contoh. 1',
              value: this.$route.params.id,
              width: '20%',
              required: false,
              hide: true
            },
            {
              field: 'url',
              label: 'Gambar',
              type: 'image',
              placeholder: 'Contoh. Image',
              value: '',
              width: '70%',
              required: true,
              rules: 'required'
            },
            {
              field: 'note',
              label: 'Catatan',
              type: 'textarea',
              placeholder: 'Contoh. Tuliskan catatan disini . . .',
              value: '',
              width: '100%',
              rows: 3,
              required: true,
              rules: 'required'
            },
            {
              field: 'date',
              label: 'Tanggal',
              type: 'date',
              placeholder: 'Contoh. 2010-08-20',
              value: '',
              width: '45%',
              required: true,
              rules: 'required'
            }
          ],

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: false,
              api: ''
            },
            add: {
              button: true,
              api: 'admin/user_medical/add',
              window: false,
              href: ''
            },
            edit: {
              button: true,
              api: 'admin/user_medical/update',
              window: false,
              href: ''
            },
            delete: {
              button: true,
              api: 'admin/user_medical/delete'
            },
            detail: {
              button: false,
              api: ''
            },
            attachment: {
              button: false,
              api: ''
            },
            active: {
              button: false,
              api: ''
            },
            deactive: {
              button: false,
              api: '',
              form: {}
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: true,
              api: ''
            },
            hide: {
              button: true,
              api: ''
            }
          }
        }
      }
    }
  }
</script>